<template>
  <el-card class="box-card">
    <div>
      <el-form :mode="dataTransForm" label-width="150px">
        <el-divider content-position="left">
          {{ $t('developer.dataTransfer') }}
        </el-divider>
        <el-form-item :label="$t('developer.abnormalRemind')">
          <el-switch
            v-model="dataTransForm.enable"
            active-color="#13ce66"
            @change="dataTransSwtich"
          >
          </el-switch>
        </el-form-item>
        <template v-if="dataTransForm.enable">
          <el-form-item :label="$t('developer.remindSet')">
            <el-select
              v-model="dataTransForm.cronExpression"
              :placeholder="$t('common.chooseOptions')"
              style="width: 120px;"
            >
              <el-option
                v-for="item in cronExpOptions"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            {{ $t('developer.remindSet1') }}
            <el-select
              v-model="dataTransForm.threshold"
              :placeholder="$t('common.chooseOptions')"
              style="width: 120px;"
            >
              <el-option
                v-for="item in thresholdOptions"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            {{ $t('developer.remindSet2') }}
          </el-form-item>
          <template v-for="(item, index) in dataTransEmail">
            <el-form-item
              :label="$t('developer.receiveMail') + `${index + 1}`"
              :key="index"
            >
              <el-row :gutter="20">
                <el-col :span="8" style="padding-left:0">
                  <el-input v-model="item.mail" placeholder=""></el-input>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="primary"
                    @click="addEmail('dataTransForm')"
                    v-if="index === 0"
                  >
                    {{ $t('operation.addNew') }}
                  </el-button>
                  <i
                    v-else
                    class="el-icon-remove"
                    style="color:#f56c6c;cursor: pointer;"
                    @click="removeEmail('dataTransForm', index)"
                  ></i>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </template>
      </el-form>
    </div>

    <div>
      <el-form :model="apiForm" label-width="150px">
        <el-divider content-position="left">API</el-divider>
        <el-form-item :label="$t('developer.abnormalRemind')">
          <el-switch
            v-model="apiForm.enable"
            active-color="#13ce66"
            @change="apiSwitch"
          >
          </el-switch>
        </el-form-item>
        <template v-if="apiForm.enable">
          <el-form-item :label="$t('developer.remindSet')">
            <el-select
              v-model="apiForm.cronExpression"
              :placeholder="$t('common.chooseOptions')"
              style="width: 120px;"
            >
              <el-option
                v-for="item in cronExpOptions"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            {{ $t('developer.remindSet1') }}
            <el-select
              v-model="apiForm.threshold"
              :placeholder="$t('common.chooseOptions')"
              style="width: 120px;"
            >
              <el-option
                v-for="item in thresholdOptions"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            {{ $t('developer.remindSet2') }}
          </el-form-item>
          <template v-for="(item, index) in apiEmail">
            <el-form-item
              :label="$t('developer.receiveMail') + `${index + 1}`"
              :key="index"
            >
              <el-row :gutter="20">
                <el-col :span="8" style="padding-left:0">
                  <el-input v-model="item.mail" placeholder=""></el-input>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="primary"
                    @click="addEmail('api')"
                    v-if="index === 0"
                  >
                    {{ $t('operation.addNew') }}
                  </el-button>
                  <i
                    v-else
                    class="el-icon-remove"
                    style="color:#f56c6c;cursor: pointer;"
                    @click="removeEmail('api', index)"
                  ></i>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </template>
      </el-form>
    </div>
    <div>
      <el-form :model="apiReportForm" label-width="150px">
        <el-divider content-position="left">
          {{ $t('developer.apiReport') }}
        </el-divider>
        <el-form-item :label="$t('developer.statisticsRemind')">
          <el-switch
            v-model="apiReportForm.enable"
            active-color="#13ce66"
            @change="apiReportSwitch"
          />
        </el-form-item>
        <template v-if="apiReportForm.enable">
          <el-form-item :label="$t('developer.statisticsReport')">
            <el-row>
              <el-checkbox v-model="dayChecked" @change="daySwitch">
                {{ $t('developer.daily') }}
              </el-checkbox>
              <el-time-picker
                v-model="dayTime"
                format="HH:mm"
                value-format="HH:mm"
                :disabled="!dayChecked"
                :clearable="false"
              >
              </el-time-picker>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('developer.dailyTips')"
                placement="bottom"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-row>
            <el-row style="margin:10px 0">
              <el-checkbox v-model="weekChecked" @change="weekSwitch">
                {{ $t('developer.week') }}
              </el-checkbox>
              <el-time-picker
                v-model="weekTime"
                format="HH:mm"
                value-format="HH:mm"
                :disabled="!weekChecked"
                :clearable="false"
              >
              </el-time-picker>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('developer.weekTips')"
                placement="bottom"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-row>
            <el-row>
              <el-checkbox v-model="monthChecked" @change="monthSwitch">
                {{ $t('developer.month') }}</el-checkbox
              >
              <el-time-picker
                v-model="monthTime"
                format="HH:mm"
                value-format="HH:mm"
                :disabled="!monthChecked"
                :clearable="false"
              >
              </el-time-picker>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('developer.monthTips')"
                placement="bottom"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-row>
          </el-form-item>
          <template v-for="(item, index) in apiReportEmail">
            <el-form-item
              :label="$t('developer.receiveMail') + `${index + 1}`"
              :key="index"
            >
              <el-row :gutter="20">
                <el-col :span="8" style="padding-left:0">
                  <el-input v-model="item.mail" placeholder=""></el-input>
                </el-col>
                <el-col :span="6">
                  <el-button
                    type="primary"
                    @click="addEmail('apiReport')"
                    v-if="index === 0"
                  >
                    {{ $t('operation.addNew') }}
                  </el-button>
                  <i
                    v-else
                    class="el-icon-remove"
                    style="color:#f56c6c;cursor: pointer;"
                    @click="removeEmail('apiReport', index)"
                  ></i>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </template>
      </el-form>
      <el-row style="text-align:center">
        <el-button type="primary" @click="sumbitAppMsg">
          {{ $t('operation.confirm') }}</el-button
        >
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { getByType } from '@/cdpBase/services/dictionary.js'
import { setAppRule, getAppRule } from '@/services/appManagerApi.js'

export default {
  props: {
    appInfo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      dayTime: '',
      dayChecked: false,
      dayCheckedCopy: false,
      weekTime: '',
      weekChecked: false,
      weekCheckedCopy: false,
      monthTime: '',
      monthChecked: false,
      monthCheckedCopy: false,
      dataTransEmail: [{ mail: '' }],
      apiEmail: [{ mail: '' }],
      apiReportEmail: [{ mail: '' }],
      dataTransForm: {
        enable: 0,
        cronExpression: '',
        cronVal: '',
        threshold: '',
        id: ''
      },
      apiForm: {
        enable: 0,
        cronExpression: '',
        cronVal: '',
        threshold: '',
        id: ''
      },
      apiReportForm: {
        enable: 0,
        dayReport: {
          enable: 0,
          min: '',
          hour: '',
          id: ''
        },
        weekReport: {
          enable: 0,
          min: '',
          hour: '',
          id: ''
        },
        monthReport: {
          enable: 0,
          min: '',
          hour: '',
          id: ''
        }
      },
      cronExpOptions: [],
      thresholdOptions: [],
      isHasData: false
    }
  },
  methods: {
    handleSwitch(type, flag) {
      // 处理 cronExpression || cronVal || threshold （回显|默认值）
      let data = {
        dataTransForm: this.dataTransForm,
        apiForm: this.apiForm
      }
      Object.keys(data).map(key => {
        if (key === type) {
          if (flag) {
            data[key].cronExpression =
              data[key].cronExpression || this.cronExpOptions[0].value
            data[key].cronVal = data[key].cronVal || this.cronExpOptions[0].name
            data[key].threshold =
              data[key].threshold || this.thresholdOptions[0].value
          } else {
            data[key].cronExpression = ''
            data[key].cronVal = ''
            data[key].threshold = ''
          }
        }
      })
    },
    dataTransSwtich(val) {
      this.handleSwitch('dataTransForm', val)
    },
    apiSwitch(val) {
      this.handleSwitch('apiForm', val)
    },
    daySwitch(val) {
      this.dayCheckedCopy = val // 记录checkbox的值 为了统计提醒关闭保持上一次选择的状态
    },
    weekSwitch(val) {
      this.weekCheckedCopy = val
    },
    monthSwtich(val) {
      this.monthCheckedCopy = val
    },
    apiReportSwitch(val) {
      // 处理 日|周|月报 check状态及相应时间 （回显|默认值）
      if (!this.isHasData) {
        this.dayChecked = val
        this.weekChecked = val
        this.monthChecked = val
      } else {
        this.dayChecked = this.dayChecked
        this.weekChecked = this.weekChecked
        this.monthChecked = this.monthChecked
      }

      this.apiReportForm['dayReport'].enable = val ? 1 : 0
      this.apiReportForm['weekReport'].enable = val ? 1 : 0
      this.apiReportForm['monthReport'].enable = val ? 1 : 0
      if (val) {
        let date = new Date()
        let time = `${date.getHours()}:${date.getMinutes()}`
        !this.dayTime && (this.dayTime = time)
        !this.weekTime && (this.weekTime = time)
        !this.monthTime && (this.monthTime = time)
      }
    },

    handleEmail() {
      let relayEmail = {}
      this.dataTransEmail.forEach((item, index) => {
        relayEmail[`mail${index + 1}`] = item.mail
      })
      let apiEmail = {}
      this.apiEmail.forEach((item, index) => {
        apiEmail[`mail${index + 1}`] = item.mail
      })
      let apiReportEmail = {}
      this.apiReportEmail.forEach((item, index) => {
        apiReportEmail[`mail${index + 1}`] = item.mail
      })
      return {
        relayEmail,
        apiEmail,
        apiReportEmail
      }
    },

    getDicValueLabel(val) {
      let result = this.cronExpOptions.filter(item => {
        if (item.value === val) {
          return item
        }
      })
      if (result.length !== 0) {
        return result[0].name
      } else {
        return ''
      }
    },

    deleteSumbitEmail() {
      let mail = {
        dataTransForm: this.dataTransForm,
        apiForm: this.apiForm,
        apiReportForm: this.apiReportForm
      }
      Object.keys(mail).map(key => {
        Object.keys(mail[key]).map(o => {
          if (o.startsWith('mail')) {
            delete mail[key][o] // 三个邮箱中以mail 开头的属性
          }
        })
      })
    },
    setEnable(val) {
      return val === true ? 1 : 0
    },
    handleApiReportFormData() {
      const type = ['dayReport', 'weekReport', 'monthReport']
      let checked = {
        dayReport: this.dayChecked,
        weekReport: this.weekChecked,
        monthReport: this.monthChecked
      }
      let time = {
        dayReport: this.dayTime,
        weekReport: this.weekTime,
        monthReport: this.monthTime
      }
      type.forEach(item => {
        this.apiReportForm[item].enable = checked[item] === true ? 1 : 0 // 是否开启日|周|月报
        Object.keys(time).map(key => {
          if (item !== key) return
          if (time[key]) {
            let t = time[key].split(':')
            this.apiReportForm[item].hour = t[0]
            this.apiReportForm[item].min = t[1]
          } else {
            this.apiReportForm[item].hour = ''
            this.apiReportForm[item].min = ''
          }
        })
      })
    },
    sumbitAppMsg() {
      this.showLoad(this.$t('operation.saving'))
      let { relayEmail, apiEmail, apiReportEmail } = this.handleEmail()
      this.deleteSumbitEmail() // 删除回显数据中mail
      this.handleApiReportFormData() // 提交前数据处理

      this.dataTransForm.enable = this.setEnable(this.dataTransForm.enable)
      this.apiForm.enable = this.setEnable(this.apiForm.enable)
      this.apiReportForm.enable = this.setEnable(this.apiReportForm.enable)
      this.dataTransForm.cronVal = this.getDicValueLabel(
        this.dataTransForm.cronExpression
      )
      this.apiForm.cronVal = this.getDicValueLabel(this.apiForm.cronExpression)

      let params = {
        appKey: this.appInfo.appKey,
        relay: {
          ...this.dataTransForm,
          ...relayEmail
        },
        api: {
          ...this.apiForm,
          ...apiEmail
        },
        apiReport: {
          ...this.apiReportForm,
          ...apiReportEmail
        }
      }
      setAppRule(params)
        .then(data => {
          if (data.code === '00000000') {
            this.getAppRule()
          } else {
            this.errorMessage(data.methods)
          }
        })
        .catch(e => this.errorMessage())
        .finally(() => this.closeLoad())
    },

    removeEmail(type, index) {
      type === 'dataTransForm' && this.dataTransEmail.splice(index, 1)
      type === 'api' && this.apiEmail.splice(index, 1)
      type === 'apiReport' && this.apiReportEmail.splice(index, 1)
    },
    addEmail(type) {
      let email = {
        dataTransForm: this.dataTransEmail,
        api: this.apiEmail,
        apiReport: this.apiReportEmail
      }
      if (email[type].length >= 3) {
        this.$message.warning(this.$t('developer.mailSetMax'))
        return
      }
      email[type].push({ mail: '' })
    },

    getDictionaryValue() {
      let dicValue = {
        cronExpression: this.cronExpOptions,
        threshold: this.thresholdOptions
      }
      Object.keys(dicValue).forEach(key => {
        getByType(key).then(data => {
          dicValue[key].push(...data.results.results)
        })
      })
    },
    hasHourAndMin(data, type) {
      let res = ''
      if (data[type]['hour'] && data[type]['min']) {
        res = `${data[type]['hour']}:${data[type]['min']}`
      }
      return res
    },
    copyRes(data, type) {
      return Object.assign({}, data[type])
    },
    getAppRule() {
      this.showLoad()
      let params = {
        appKey: this.appInfo.appKey
      }
      getAppRule(params)
        .then(data => {
          if (data.code === '00000000') {
            let results = Object.keys(data.payload.results)
            if (results.length !== 0) {
              // 更新

              let res = data.payload.results
              this.isHasData = true
              // 日报
              if (res.relay) {
                this.dataTransForm = Object.assign({}, res.relay)
                this.dataTransForm.enable = res.relay.enable === 1

                this.dataTransEmail = [{ mail: '' }]
                res.relay.mail1 &&
                  (this.dataTransEmail[0].mail = res.relay.mail1)
                res.relay.mail2 &&
                  this.dataTransEmail.push({ mail: res.relay.mail2 })
                res.relay.mail3 &&
                  this.dataTransEmail.push({ mail: res.relay.mail3 })
              }
              if (res.api) {
                this.apiForm = Object.assign({}, res.api)
                this.apiForm.enable = res.api.enable === 1

                this.apiEmail = [{ mail: '' }]
                res.api.mail1 && (this.apiEmail[0].mail = res.api.mail1)
                res.api.mail2 && this.apiEmail.push({ mail: res.api.mail2 })
                res.api.mail3 && this.apiEmail.push({ mail: res.api.mail3 })
              }
              if (res.apiReport) {
                // apiReport 数据回显
                this.apiReportForm.enable = res.apiReport.enable === 1
                this.dayChecked = this.dayCheckedCopy =
                  res.apiReport.dayReport.enable === 1
                this.weekChecked = this.weekCheckedCopy =
                  res.apiReport.weekReport.enable === 1
                this.monthChecked = this.monthCheckedCopy =
                  res.apiReport.monthReport.enable === 1

                this.apiReportEmail = [{ mail: '' }]
                res.apiReport.mail1 &&
                  (this.apiReportEmail[0].mail = res.apiReport.mail1)
                res.apiReport.mail2 &&
                  this.apiReportEmail.push({ mail: res.apiReport.mail2 })
                res.apiReport.mail3 &&
                  this.apiReportEmail.push({ mail: res.apiReport.mail3 })

                // 拷贝返回的数据
                const type = ['dayReport', 'weekReport', 'monthReport']
                type.forEach(item => {
                  this.apiReportEmail[item] = this.copyRes(res.apiReport, item)
                })

                //  时间 回显
                this.dayTime = this.hasHourAndMin(res.apiReport, 'dayReport')
                this.weekTime = this.hasHourAndMin(res.apiReport, 'weekReport')
                this.monthTime = this.hasHourAndMin(
                  res.apiReport,
                  'monthReport'
                )
              }
            } else {
              // 新增 开启 邮箱默认个人中心
              this.isHasData = false
              !this.dayChecked &&
                (this.dataTransEmail[0].mail = this.appInfo.mail)
              !this.weekChecked && (this.apiEmail[0].mail = this.appInfo.mail)
              !this.monthChecked &&
                (this.apiReportEmail[0].mail = this.appInfo.mail)
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => {
          this.closeLoad()
        })
    }
  },

  mounted() {
    this.getDictionaryValue()
    this.getAppRule()
  }
}
</script>

<style scoped lang="less">
.app_message_cla {
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/appMessage.vue